import { useMutation, useQuery } from "@tanstack/react-query";
import { APIErrorResponse } from "src/types/generic";
import {
  IGolfRequestsParams,
  IGolfCartRequestsResponse,
  IGolfCartRequestPayload,
} from "src/types/golf-carts";
import apiFastifyClient from "./apiFastifyCloud";

export const useGetGolfCartRequests = (params?: IGolfRequestsParams) =>
  useQuery<void, APIErrorResponse, IGolfCartRequestsResponse>({
    queryKey: ["get-golf-cart-requests", params],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/requests`, { params });
    },
    gcTime: 0,
  });

export const useExportGolfCartRequests = (params: IGolfRequestsParams) =>
  useQuery<void, APIErrorResponse, any>({
    queryKey: ["export-golf-cart-requests"],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/requests/export`, { params });
    },
    gcTime: 0,
    enabled: false,
  });

export const useAddGolfCartRequestMutation = () =>
  useMutation<any, APIErrorResponse, IGolfCartRequestPayload>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/requests`, data);
    },
  });

export const useUpdateGolfCartRequestMutation = () =>
  useMutation<any, APIErrorResponse, any>({
    mutationFn: async (data) => {
      const { id, ...rest } = data;
      return apiFastifyClient.patch(`/v1/requests/${id}`, rest);
    },
  });

export const useGetGolfCartRequestById = ({ id }: { id: string }) =>
  useQuery<any, APIErrorResponse, { data: any }>({
    queryKey: ["get-driver-by-id"],
    queryFn: async () => {
      return apiFastifyClient.get(`/v1/requests/${id}`);
    },
    gcTime: 0,
    enabled: !!id,
  });

export const useCancelGolfCartRequestMutation = () =>
  useMutation<any, APIErrorResponse, { requestId: string }>({
    mutationFn: async (data) => {
      return apiFastifyClient.post(`/v1/requests/cancel`, data);
    },
  });
